import lz from "lz-string";

const backends = {
  dev: "http://localhost:8443",
  prod: "https://feedme.halodoughnut.com:8443",
  staging: "https://feedme.halodoughnut.com:18443",
};
const host =
  window.location.host == "feedme.halodoughnut.com"
    ? backends.prod
    : window.location.host == "feedme.halodoughnut.com:1443"
      ? backends.staging
      : backends.dev;
let credentials;

function __fetch(url, args) {
  return new Promise((resolve, reject) => {
    fetch(url, args)
      .then((res) => {
        if (res.ok) resolve(res);
        else reject(res.status);
      })
      .catch(reject);
  });
}

function defaultReadHeaders() {
  return { credentials };
}

function defaultWriteHeaders() {
  return { "Content-Type": "application/json", credentials };
}

function checkOTP(handle, OTP) {
  return __fetch(`${host}/otp/check`, {
    method: "POST",
    headers: defaultWriteHeaders(),
    body: JSON.stringify({ handle, OTP }),
  })
    .then((res) => res.json())
    .then((json) => json.token);
}

function createOrder(val) {
  return __fetch(`${host}/order/self`, {
    method: "POST",
    headers: defaultWriteHeaders(),
    body: JSON.stringify(val),
  })
    .then((res) => res.json())
    .then((json) => json.newId);
}

function getCustomerPromos(handle) {
  return __fetch(`${host}/promos?handle=${handle}`, {
    headers: defaultReadHeaders(),
  }).then((res) => res.json());
}

function getDeliveryCharge(slot, addr) {
  return __fetch(
    `${host}/deliveryCharge?slot=${slot}&addr=${encodeURIComponent(addr)}`,
    { headers: defaultReadHeaders() },
  ).then((res) => res.json());
}

function getMenu() {
  return __fetch(`${host}/menu`, { headers: defaultReadHeaders() })
    .then((res) => res.text())
    .then((body) => JSON.parse(lz.decompressFromUTF16(body)));
}

function igSendOTP(handle) {
  return __fetch(`${host}/otp/send`, {
    method: "POST",
    headers: defaultWriteHeaders(),
    body: JSON.stringify({ handle }),
  });
}

function init(handle, token) {
  credentials = `${handle}:${token}`;
}

function logInteraction(tag, args) {
  return __fetch(`${host}/log/interaction`, {
    method: "POST",
    headers: defaultWriteHeaders(),
    body: JSON.stringify({ tag, args }),
  });
}

function payOrder({ orderId, omiseToken, validate3dsPayment }) {
  return __fetch(`${host}/order/self/pay`, {
    method: "POST",
    headers: defaultWriteHeaders(),
    body: JSON.stringify({ orderId, omiseToken, validate3dsPayment }),
  }).then((res) => res.json());
}

function registerWithoutOTP(handle) {
  return __fetch(`${host}/register-no-otp`, {
    method: "POST",
    headers: defaultWriteHeaders(),
    body: JSON.stringify({ handle }),
  })
    .then((res) => res.json())
    .then((json) => json.token);
}

export const api = {
  checkOTP,
  createOrder,
  getCustomerPromos,
  getDeliveryCharge,
  getMenu,
  igSendOTP,
  logInteraction,
  payOrder,
  registerWithoutOTP,
  state: {
    init,
  },
};
